/**
 * @Desription: 登录-提交
 * @Author: netstar.sjj
 * @Date: 2021-10-26 10:05:00
 * @class submit
*/
import strongLogin from './strong-login';//强制登录
import passwordExpire from './password-expire';//密码超期
declare const window:any;
declare const aesjs:any;
export default function(paramsObj?:any,_otherParamObj?:any) {
    //强制登录
    const strongLoginFunc:Function = strongLogin;
    //初次登录密码，密码超期
    const passwordExpiredFunc:Function = passwordExpire;
    //登录成功
    const successFunc:Function = function(res:any, ajaxData:any,ajaxPlusData?:any){
        let config:any = window.NSLogin.config;
        if(typeof(res.data.properties)=='object'){
            res.data.properties.context.envType = res.data.envType;
            window.store.set('loginProperty',res.data.properties);//登录成功之后获取系统用户信息
        }
        window.NSLogin.loginManger.remember.set();
        //如果配置了自动登录，则保存用户名密码
        if(window.NetstarApiConfig.login && window.NetstarApiConfig.login.appAutoLogin && typeof(window._cordovaNative) == "object"){
            if(window.jQuery('#remember').prop("checked") ==  true){ 
                window.store.set('appAutoLogin', ajaxData);
            }
        }
        if(window.NetstarApiConfig.login && window.NetstarApiConfig.login.mobileAutoLogin && window.NSUtils.getBrowserVersion().browserSystem == "mobile"){
            if(window.jQuery('#remember').prop("checked") ==  true){
                window.store.set('mobileAutoLogin', ajaxData);
            }
        }
        //保存授权码
        window.NSLogin.serverData = res;
        window.NSLogin.Authorization = res.data.token;
        window.NSUtils.OAuthCode.set({
            authorization:      res.data.token, 
            expireMinute:       config.expireMinute,
            loginTimeStamp:     new Date().getTime(),
        });
        if(typeof(config.loginAjax.beforeHandler) == "function"){
            config.loginAjax.beforeHandler(config,ajaxData);
        }else{
            let urlParamsObj:any = {};
            if(typeof(ajaxPlusData)=='object' && ajaxPlusData.loginParamsType === 'deploy'){
                if(typeof(window.NetstarApiConfig.login.onClickDeploy.jump)=='object'){
                    if(window.NetstarApiConfig.login.onClickDeploy.jump.type === 'blank'){
                        window.open(window.NetstarApiConfig.login.onClickDeploy.jump.value,'_blank');
                        return;
                    }
                    urlParamsObj.nav = window.encodeURIComponent(JSON.stringify(window.NetstarApiConfig.login.onClickDeploy.jump));
                }
            }
            window.NSLogin.toHomePage(res.data.token,urlParamsObj);
        }
    }
    //登录失败
    const failFunc:Function = function(res:any){
        window.store.remove("userInfo")//清空缓存信息
        let config:any = window.NSLogin.config;
        let msgStr:string = res.msg;
        let verificationCode:boolean = false;//登录状态为4，需要验证码
        if(typeof(res.data) == 'object'){
            if(res.data.msg){
                msgStr = res.data.msg;
            }
            if(res.data.loginStatus == 4){;//登录状态为4，需要验证码
                verificationCode = true;
            }
        }
        if(window.NetstarApiConfig.version && window.NetstarApiConfig.version.indexOf('v4.1')==0){
            verificationCode = true;
        }
        window.jQuery(config.msgEl).html(msgStr);
        window.jQuery(config.msgEl).removeClass('hide');
        if(verificationCode === true){
            window.jQuery(config.verificationHidden).removeClass('hide');
        }
        let userNameVal:string = window.jQuery(config.usernameEl).val();
        let orgNameVal:string = window.jQuery(config.orgnameEl).val();
        let orgName:string = encodeURIComponent(orgNameVal);
        let userName:string = encodeURIComponent(userNameVal);
        let random:number = Math.random() * 100;
        let verificationImgUrl:string = window.NSUtils.getAPIUrl() + '/verificationCode?'+ "orgName=" + orgName +"&"+ "username=" +userName+"&random="+random;
        if(typeof(window.NSSystemConfig)=='object' && typeof(typeof(window.NSSystemConfig.login)=='object')){
            if(window.NSSystemConfig.login.verificateAjax && window.NSSystemConfig.login.verificateAjax.url){
                let verificateAjaxData = typeof(window.NSSystemConfig.login.verificateAjax.data)=='object' ? window.NSSystemConfig.login.verificateAjax.data : {};
                let verificateUrlParamsArr = [];
                if(!window.jQuery.isEmptyObject(verificateAjaxData)){
                    verificateAjaxData = window.NSUtils.getFormatParameterJSON(verificateAjaxData,{organizationName:"",orgName:orgName,username:userName,random:random});
                }
                for(let verifiKeyI in verificateAjaxData){
                    verificateUrlParamsArr.push(verifiKeyI+'='+verificateAjaxData[verifiKeyI]);
                }
                let verificateUrlParamStr = verificateUrlParamsArr.length > 0 ? verificateUrlParamsArr.join('&') : "orgName=" + orgName +"&"+ "username=" +userName+"&random="+random;
                verificationImgUrl = window.NSUtils.getAPIUrl()+window.NSSystemConfig.login.verificateAjax.url+'?'+verificateUrlParamStr;
            }
        }
        let htmlImg:string ='<img class="verification-img-size" src="'+ verificationImgUrl+'"><br/><a href="javascript:void(0);" id="refreshVerificationImg">'+window.language.login.verifiyName+'</a>';
        window.jQuery(config.verificationImgEl).html(htmlImg);
        window.jQuery('#refreshVerificationImg').off('click').on('click',window.NSLogin.loginManger.refreshVerImg);
        config.$login.removeClass('login-loading');
    }
    let config:any = window.NSLogin.config;
    let username:string = window.jQuery(config.usernameEl).val();
    let password:string = window.jQuery(config.passwordEl).val();
    let verificationCode:string = window.jQuery(config.verificationCodeEl).val();
    //当前提交是通过点击一键部署走的提交，那么用户名和密码从配置映射web-config.js参数定义中读取
    let loginParamsTypeStr:string = 'default';
    if(typeof(_otherParamObj)=='object' && _otherParamObj.loginParamsType === 'deploy'){
        username = window.NetstarApiConfig.login.onClickDeploy.userName;
        password = window.NetstarApiConfig.login.onClickDeploy.pwd;
        loginParamsTypeStr = _otherParamObj.loginParamsType;
    }
    if(username == ''){
        window.jQuery(config.msgEl).html(window.language.login.username);
        window.jQuery(config.msgEl).removeClass('hide');
        config.$login.removeClass('login-loading');
        return;
    }
    if(password == ''){
        window.jQuery(config.msgEl).html(window.language.login.pwd);
        window.jQuery(config.msgEl).removeClass('hide');
        config.$login.removeClass('login-loading');
        return;
    }
    if(window.NetstarApiConfig.rememberUser&&window.NSUtils.getBrowserVersion().browserSystem!=="pc"&&window.cordova){
        window.store.set("userInfo",{userName:username,password:password,orgName:window.jQuery(config.orgnameEl).val()})//设置缓存信息
    }
    let passwordIsMD5:boolean = true;
    let appAutoLogin = false;
    if(typeof(paramsObj) == 'object'){
        if(typeof(paramsObj.passwordIsMD5) == 'boolean'){
            passwordIsMD5 = paramsObj.passwordIsMD5;
            appAutoLogin = true;
        }
    }
    if(appAutoLogin == false){
        if(window.NetstarApiConfig.login){
            if(window.NetstarApiConfig.login.passwordIsMD5 == false){
                passwordIsMD5 = false;
            }
        }
    }
    if(passwordIsMD5 === true){
        password = window.hex_md5(password);
    }
    let ajaxData:any = {
        login: 1,
        username: username,
        password: password,
        verificationCode: verificationCode,
        withProperties:1
    };
    if(typeof(window.NetstarApiConfig.login)=='object'){
        switch(window.NetstarApiConfig.login.loginMode){
            case 'user':
                ajaxData.deviceType = 9999;
                break;
            case 'device':
                //登录的时候配置了是单用户还是单设备
                const curBrowserSystem:string = window.NSUtils.getBrowserVersion().browserSystem;
                if(curBrowserSystem === 'pc'){
                    ajaxData.deviceType = 1;
                }else if(curBrowserSystem === 'mobile'){
                    ajaxData.deviceType = 2;
                }else if(curBrowserSystem === 'pad'){
                    ajaxData.deviceType = 3;
                }
                break;
            default:
                break;
        }
    }
    if(config.version === "v4"){
        delete ajaxData.withProperties;
    }
    if(!window.jQuery.isEmptyObject(paramsObj)){
        for(let pushParamI in paramsObj){
            ajaxData[pushParamI] = paramsObj[pushParamI];
        }
    }
    if(config.orgnameEl){
        ajaxData.orgName = window.jQuery(config.orgnameEl).val();
    }
    if(loginParamsTypeStr === 'deploy' && window.NetstarApiConfig.login.onClickDeploy.orgName){
        ajaxData.orgName = window.NetstarApiConfig.login.onClickDeploy.orgName;
    }
    if(window.NetstarApiConfig.login){
        if(window.NetstarApiConfig.login.orgnameEl === false){
            if(typeof(ajaxData.orgName) != 'undefined'){
                delete ajaxData.orgName;
            }
        }
    }
    
    let urlParams:any = window.NSUtils.getUrlPara();
    if(typeof(urlParams)=='object'){
        window.jQuery.each(urlParams, function(key:string,value:any){
            switch(key){
                case 'callback':
                    //callback是一个json文本 需要decode 例如 %257B%2522customerId%2522:1310336379963573234%257D  => {"customerId":1310336379963573234}
                    ajaxData[key] = decodeURIComponent(value);
                    break;
                default:
                    break;
            }
        });
    }
    if(typeof(config.loginAjax.handler)=='function'){
        config.loginAjax.handler(config,ajaxData);
        config.$login.removeClass('login-loading');
        return;
    }
    let contentTypeStr:string = 'application/x-www-form-urlencoded';//sjj 定义contentType
    if(config.loginAjax.contentType){
        contentTypeStr = config.loginAjax.contentType;
    }
    if(contentTypeStr == 'application/json'){
        contentTypeStr = 'application/json; charset=utf-8';
    }
    let methodStr:string = config.loginAjax.method ? config.loginAjax.method : 'GET';
    if(config.loginAjax.type){
        methodStr = config.loginAjax.type;
    }
    if(contentTypeStr == 'application/json; charset=utf-8'){
        ajaxData = JSON.stringify(ajaxData);
    }
    if(config.appName === 'hysw'){
        config.loginAjax.url += '?token='+username;
    }

    // ajax前置回调
    if(typeof(config.loginAjax.ajaxBeforeHandler) == 'function'){
        ajaxData = config.loginAjax.ajaxBeforeHandler(config.loginAjax, ajaxData)
    }
    const ajaxUrlStr:string = window.NSUtils.getUrl(config.loginAjax.url);
    let ajaxConfig:any = {
        type: methodStr,
        dataType: 'json',
        url: ajaxUrlStr,
        data: ajaxData,
        contentType:contentTypeStr,
        plusData:{
            loginParamsType:loginParamsTypeStr
        },
        success: function (res:any) {
            // aes 解密
            if(typeof(aesjs) != 'undefined'){
                if (aesjs.needEncrypt(ajaxConfig)) {
                    var aesUtil = new aesjs.AesUtil();
                    res = aesUtil.decrypt(res);
                }
            }
            res = typeof(res)=='object' ? res : {};
            let resData:any = typeof(res.data)=='object' ? res.data : {};
            let _ajaxData = this.data;
            try {
                _ajaxData = JSON.parse(this.data);
            } catch (error) {
                _ajaxData = ajaxData
            }
            
            if(res.success === true){
                resData.success = true;
            }
            if(resData.loginStatus === 8){
                strongLoginFunc();//强制登录
            }else if(resData.loginStatus === 2 || resData.passwordExpired === true){
                passwordExpiredFunc();//密码超期
            }else{
                if(resData.success === true){
                    successFunc(res,_ajaxData,this.plusData);//登录成功
                }else{
                    failFunc(res,_ajaxData,this.plusData);//登录失败
                }
            }
        },
        error:window.NSLogin.ajaxError
    };
    if(!window.jQuery.isEmptyObject(config.loginAjax.headers)){
        ajaxConfig.headers = config.loginAjax.headers;
    }
    // dc aes加密
    if(typeof(aesjs) != 'undefined'){
        if (aesjs.needEncrypt(ajaxConfig)) {
            aesjs.encrypt(ajaxConfig);
        }
    }
    window.jQuery.ajax(ajaxConfig);
};